import { render } from "./ProductSelectModule.vue?vue&type=template&id=4de078ae&scoped=true"
import script from "./ProductSelectModule.vue?vue&type=script&lang=js"
export * from "./ProductSelectModule.vue?vue&type=script&lang=js"

import "./ProductSelectModule.vue?vue&type=style&index=0&id=4de078ae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de078ae"]])

export default __exports__